import { FC, useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { TourProvider } from '@reactour/tour';
import { useTranslatedSteps } from './stepsTour';
import VideoProvider from '../components/VideoProvider';
import { videoUrls, videoTitles } from '../utils/videoUrls';
import { ProfileContent } from './Profile';
import { BusinessContent } from './Business';
import { getSubscriptionInfo } from '../services/api';
import { useTranslation } from '../contexts/TranslationContext';

const ProfileAndBusiness: FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();
  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const response = await getSubscriptionInfo();
        if (response.has_active_subscription && response.data) {
        }
      } catch (error) {
        console.error('Error fetching subscription info:', error);
      }
    };

    checkSubscription();
  }, []);

  const steps = [
    ...useTranslatedSteps().steps_profile,
    ...useTranslatedSteps().steps_business,
  ];

  return (
    <TourProvider steps={steps}>
      <VideoProvider videoUrl={videoUrls.profile} videoTitle={videoTitles.profile}>
        <Box sx={{ width: '100%', p: 2, pt:{xs:0, md:2} }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
            <Tabs
              value={activeTab}
              onChange={(_, newValue) => setActiveTab(newValue)}
              aria-label="profile and business tabs"
              sx={{
                border: '1.5px solid black',
                borderBottom: 'none',
                borderTopRightRadius: { xs: '10px', sm: '14px', md: '16px' },
                borderTopLeftRadius: { xs: '10px', sm: '14px', md: '16px' },
                '& .MuiTabs-flexContainer': { justifyContent: 'center' },
                '& .MuiTabs-indicator': { display: 'none' },
                '& .MuiTab-root': {
                  backgroundColor: '#D9D9D980',
                  color: '#000',
                  fontWeight: 400,
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  minWidth: { xs: '60px', sm: '80px', md: '120px' },
                  flex: '1 1 0',
                  textAlign: 'center',
                  fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.875rem' },
                  px: { xs: 0.75, sm: 1, md: 2 },
                  py: { xs: 0.75, sm: 1, md: 1.25 },
                  whiteSpace: 'nowrap',
                },
                '& .MuiTab-root:first-of-type': {
                  borderTopLeftRadius: { xs: '9px', sm: '13px', md: '15px' },
                  borderRight: '1.5px solid black',
                },
                '& .MuiTab-root:last-of-type': { borderTopRightRadius: { xs: '9px', sm: '13px', md: '15px' } },
                '& .MuiTab-root.Mui-selected': {
                  backgroundColor: '#009688',
                  color: '#fff',
                  fontWeight: 700,
                },
              }}
            >
              <Tab label={t('profileAndBusiness.tabs.profile')} id="profile-tab-0" aria-controls="profile-tabpanel-0" />
              <Tab label={t('profileAndBusiness.tabs.business')} id="profile-tab-1" aria-controls="profile-tabpanel-1" />
            </Tabs>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              overflow: 'auto',
              minHeight: 0,
              border: '1.5px solid black',
              borderRadius: '20px',
            }}
          >
            {activeTab === 0 && (
              <Box
                id="profile-tabpanel-0"
                role="tabpanel"
                aria-labelledby="profile-tab-0"
                sx={{ width: '100%', height: '100%' }}
              >
                <ProfileContent />
              </Box>
            )}
            {activeTab === 1 && (
              <Box
                id="profile-tabpanel-1"
                role="tabpanel"
                aria-labelledby="profile-tab-1"
                sx={{ width: '100%', height: '100%' }}
              >
                <BusinessContent />
              </Box>
            )}
          </Box>
        </Box>
      </VideoProvider>
    </TourProvider>
  );
};

export default ProfileAndBusiness;

